// extracted by mini-css-extract-plugin
module.exports = {"bottomContainer":"form-modal_bottomContainer__QClZy"};